<template>
  <div>
    <div class=" absolute top-0 left-0" v-if="cvs">
      <!-- {{ cvs.city.types }} -->
      <!-- {{ cvs.city.list.map(e => e.name).join('\n') }} -->
    </div>
  </div>
</template>

<script>
import { EffectNode } from "../EffectNode/Core/EffectNode"

// Stack
import { EditorAmmo } from '../EffectNode/Packages/Ammo/EditorAmmo.js'
import { Clock, Scene, AmbientLight, Color, HemisphereLight, Vector3 } from "three"
import { GLRenderer } from "../EffectNode/WebGL/GLRenderer"
import { GLCamera } from "../EffectNode/WebGL/GLCamera"
import { MapControls } from 'three/examples/jsm/controls/OrbitControls'
import { InteractionManager } from 'three.interaction' // original

//
import { Commander } from '../EffectNode/Packages/Commander/Commander'
import { LightShadow } from '../EffectNode/Packages/Commander/LightShadow'
import { Floor } from '../EffectNode/Packages/Commander/Floor'
import { ShaderCubeChrome } from '../EffectNode/Packages/Shaders/ShaderCubeChrome'
import { Cathedral } from '../EffectNode/Packages/Cathedral/Cathedral.js'

// import { ParticleGLB } from '../EffectNode/Packages/ParticleGLB/ParticleGLB.js'
// import { Factory } from '../EffectNode/Packages/Factory/Factory.js'

//
export class MyCanvas extends EffectNode {
  constructor ({ el }) {
    super()
    this.el = el
    this.setup()
  }
  async setup () {
    // Application Core
    let ctx = this
    this.renderer = new GLRenderer({ ctx })
    this.camera = new GLCamera({ ctx })
    this.camera.position.z = 150
    this.camera.position.y = 100

    this.scene = new Scene()
    this.scene.visible = false

    this.onLoop(() => {
      this.renderer.render(this.scene, this.camera)
    })

    this.controls = new MapControls(ctx.camera, ctx.renderer.domElement)
    this.controls.maxDistance = 500
    this.controls.minDistance = 3
    this.controls.enabled = true
    this.controls.enablePan = true
    this.controls.enableDamping = true
    this.controls.enableRotate = false
    this.controls.screenSpacePanning = false
    this.onLoop(() => {
      this.controls.update()
    })

    let activeChildren = []
    this.interaction = new InteractionManager(ctx.renderer, new Proxy(ctx.scene, {
      get: (obj, key) => {
        if (key === 'children') {
          activeChildren.splice(0, activeChildren.length)
          ctx.scene.traverse((item) => {
            if (item.userData.interactive) {
              activeChildren.push(item)
            }
          })
          return activeChildren
        }
        return obj[key]
      },
      set: (obj, key, val) => {
        obj[key] = val
        return true
      }
    }), ctx.camera, {
      interactionFrequency: 3
    })

    this.clock = new Clock()
    this.ammo = new EditorAmmo({ ctx: this.node({ name: 'ammo' }) })

    this.chroma = new ShaderCubeChrome({ ctx: this.node(), res: 512 })
    this.chroma.compute({ time: Math.PI * 0.6 })
    this.scene.environment = this.chroma.out.envMap
    this.scene.background = this.chroma.out.envMap

    this.light = new LightShadow({ ctx: this.node({ name: 'light' }), showHelper: process.env.NODE_ENV === 'development' })

    ctx.scene.add(new AmbientLight(new Color('#ffffff'), 0.7))
    ctx.scene.add(new HemisphereLight(new Color('#ffffff'), new Color('#bababa'), 0.7))

    await Promise.all([
      this.ammo.wait()
    ])

    // Content
    this.commander = new Commander({ char: 'swat', ctx: this.node({ name: 'commander' }), o3d: this.scene })
    this.cathedral = new Cathedral({ mount: ctx.scene, ctx: this })
    this.floor = new Floor({ ctx: this })
    // this.factory = new Factory({ ctx: this.node({ name: 'factory' }), mount: ctx.scene })

    await Promise.all([
      this.cathedral.wait(),
      // this.factory.wait(),
      this.commander.wait()
    ])

    // begin peer object access after all are loaded

    // new RandomItems({ ctx })

    // new ParticleGLB({
    //   ctx,
    //   url: require('file-loader!./glb/swat.glb'),
    //   actions: [
    //     {
    //       name: 'happy',
    //       type: 'fbx',
    //       url: require('file-loader!./glb/happy-idle.fbx')
    //     }
    //   ]
    // })

    // camera, lights, shaodw cast,

    let actorO3D = this.commander.actorO3D
    let lastPos = new Vector3().copy(actorO3D.position)
    let deltaPos = new Vector3()

    ctx.controls.target.copy(actorO3D.position)
    ctx.controls.target.y += 20

    ctx.camera.position.copy(actorO3D.position)
    ctx.camera.position.y += 150
    ctx.camera.position.z += 350

    ctx.onLoop(() => {
      let light = this.light.light
      let lightPos = this.light.lightPos
      let tracker = this.commander.actorO3D

      tracker.getWorldPosition(light.position)
      light.position.add(lightPos)
      tracker.getWorldPosition(light.target.position)
      light.target.lookAt(tracker.position)

      deltaPos.copy(actorO3D.position).sub(lastPos)
      lastPos.copy(actorO3D.position)

      ctx.controls.target.add(deltaPos)
      ctx.camera.position.add(deltaPos)
    })

    ctx.scene.visible = true
  }
}

// class RandomItems {
//   constructor ({ ctx }) {
//     this.ctx = ctx

//     let make = () => {
//       for (let i = 0; i < 20; i++) {
//         let boxGeo = new BoxBufferGeometry(30, 30, 30, 2, 2, 2)
//         let boxMat = new MeshStandardMaterial({ color: 0xffffff * Math.random(), envMap: ctx.chroma.out.envMap })

//         let boxMesh = new Mesh(boxGeo, boxMat)

//         boxMesh.position.x = (Math.random() - 0.5) * 1000
//         boxMesh.position.z = (Math.random() - 0.5) * 1000
//         boxMesh.position.y = 20

//         ctx.ammo.addSimpleMesh({ mesh: boxMesh, mass: 0.6, rootScale: 1 })
//         ctx.scene.add(boxMesh)
//       }
//     }
//     make()
//   }
// }


export default {
  data () {
    return {
      cvs: false
    }
  },
  mounted () {
    this.cvs = new MyCanvas({ el: this.$el })
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      window.location.reload()
    }
  }
}
</script>

<style>

</style>
